<template>
  <b-card title="ผลการค้นหา">
    <!-- search input -->
    <div class="custom-search d-flex justify-content-end">
      <!-- <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1">Search</label>
          <b-form-input
            v-model="searchTerm"
            placeholder="Search"
            type="text"
            class="d-inline-block"
          />
        </div>
      </b-form-group> -->
    </div>

    <!-- table -->
    <vue-good-table
      :columns="columns"
      :rows="rows"
      :rtl="direction"
      :line-numbers="true"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm,
      }"
      :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: false, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }"
      :pagination-options="{
        enabled: true,
        perPage: pageLength,
      }"
    >
      <template slot="table-row" slot-scope="props">
        <!-- Column: Name -->
        <span v-if="props.column.field === 'description'" class="text-nowrap">
          <span class="text-nowrap">{{ props.row.description }}</span>
        </span>

        <!-- Column: Name -->
        <span v-if="props.column.field === 'isActive'" class="text-nowrap">
          <span class="text-nowrap">{{
            props.row.isActive === true ? "ใช้งาน" : "ไม่ใช้งาน"
          }}</span>
        </span>
        <!-- Column: Name -->
        <span v-if="props.column.field === 'updateDate'" class="text-nowrap">
          <span class="text-nowrap">{{ props.row.updateDateStr }}</span>
        </span>
        <!-- Column: Action -->
        <span v-else-if="props.column.field === 'action'">
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="outline-primary"
                  class="text-body align-middle mr-25"
                >
                  <feather-icon icon="SettingsIcon" class="mr-50" />
                  <span class="align-middle">จัดการ</span>
                </b-button>
              </template>
              <b-dropdown-item @click="onManageBtnClicked(props.row.masterId)">
                <feather-icon icon="Edit2Icon" class="mr-50" />
                <span>แก้ไข</span>
              </b-dropdown-item>
              <b-dropdown-item
                @click="onDeleteBtnClicked(props.row.masterId)"
              >
                <feather-icon icon="TrashIcon" class="mr-50" />
                <span>ลบ</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>

        <!-- Column: Common -->
        <!-- <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span> -->
      </template>

      <!-- pagination -->
      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap ">
              แสดง 1 ถึง
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['10', '50', '100']"
              class="mx-1"
              @input="
                (value) => props.perPageChanged({ currentPerPage: value })
              "
            />
            <span class="text-nowrap"> จาก {{ props.total }} รายการ </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  </b-card>
</template>

<script>
import {
  BButton,
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BCard,
  BCardHeader,
  BCardBody,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import Ripple from "vue-ripple-directive";
import store from "@/store/index";
import { codeBasic } from "@/views/table/vue-good-table/code";
import TableHeaders from "./commonTableHeader.js";
import * as roleStore from "@/store/api/role/index.js";
import * as userData from "@/auth/localStorageUtils.js";
import * as ComplaintAPI from "@/store/api/complaint/complaint.js";

import * as storeMaster from "@/store/api/master/index.js";

export default {
  directives: {
    Ripple,
  },
  components: {
    VueGoodTable,
    BButton,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BCard,
    BCardHeader,
    BCardBody,
    TableHeaders,
    ComplaintAPI
  },
  props: {
    routeName: String,
  },
  data() {
    return {
      pageLength: 10,
      dir: false,
      codeBasic,
      columns: TableHeaders,
      rows: [],
      searchTerm: "",
      status: [
        {
          1: "Current",
          2: "Professional",
          3: "Rejected",
          4: "Resigned",
          5: "Applied",
        },
        {
          1: "light-primary",
          2: "light-success",
          3: "light-danger",
          4: "light-warning",
          5: "light-info",
        },
      ],
    };
  },
  computed: {
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Current: "light-primary",
        Professional: "light-success",
        Rejected: "light-danger",
        Resigned: "light-warning",
        Applied: "light-info",
        /* eslint-enable key-spacing */
      };

      return (status) => statusColor[status];
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
  },
  created() {

      //set up masterTypeId
      if(this.routeName == 'MasterComplaintCategory'){
        this.masterTypeId = 5;
      }
      else if(this.routeName == 'MasterComplaintType'){
        this.masterTypeId = 6;
      }
      else if(this.routeName == 'MasterComplaintCause'){
        this.masterTypeId = 7;
      }
      else if(this.routeName == 'MasterComplaintChannel'){
        this.masterTypeId = 1;
      }

    this.onSearchSubmit({});
  },
  methods: {
    onSearchSubmit(params) {
      //console.log('onSearchSubmit', params)

      params.userActive = userData.userId();
    
      var _this = this;
      //console.log("params:", this.routeName);


      // var masterTypeId = 0;
      // if(this.routeName == 'MasterPurchasePlace'){
      //   masterTypeId = 8;
      // }
      // else if(this.routeName == 'MasterPurchasePropagate'){
      //   masterTypeId=9;
      // }
      // else if(this.routeName == 'MasterPurchaseMethod'){
      //   masterTypeId = 10;
      // }
      
      storeMaster.TmMasterGetListByMasterTypeID(_this.masterTypeId,params)
      .then(function(response) {
        console.log("data", response.data.data);

        _this.rows = response.data.data;
      })
      .catch(function(error) {
        // handle error
        console.log("error", error);
      })
      .then(function() {
        // always executed
        //console.log('GET')
      });




      // roleStore
      //   .search(params)
      //   .then(function(response) {
      //     // handle success
      //     console.log("then", response);
      //     _this.rows = response.data.data;
      //     console.log("result", _this.rows);
      //   })
      //   .catch(function(error) {
      //     // handle error
      //     console.log("error", error);
      //   })
      //   .then(function() {
      //     // always executed
      //     console.log("GET");
      //   });
    },
    // onMenuBtnClicked(id) {
    //   window.open(
    //     this.$router.resolve({ name: "RoleMenu", query: { id } }).href,
    //     "_blank"
    //   );
    // },
    onManageBtnClicked(masterId) {

      var masterTypeId = this.masterTypeId
      window.open(
        this.$router.resolve({ name: (this.routeName+"Manage"), query: { masterTypeId, masterId } }).href,
        "_blank"
      );
    },
    onDeleteBtnClicked(id) {

      const _this = this

      this.$swal({
        title: "คุณต้องการลบข้อมูลใช่หรือไม่?",
        text: "เมื่อลบแล้วไม่สามารถกู้คืนได้อีก!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "ลบข้อมูล",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          storeMaster.TmMasterDelete(id)
          .then((response) => {
              if (response.data.success === true) {
                this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
                  title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
                  variant: "success",
                  solid: false,
                });

                this.onSearchSubmit({});
              } else {
                _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                  title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                  variant: "danger",
                  solid: false,
                });
              }
            })
            .catch((error) => {
              console.log("error", error);
              _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                variant: "danger",
                solid: false,
              });
            });


          // roleStore
          //   .deleteItem(id)
          //   .then((response) => {
          //     if (response.data.success === true) {
          //       this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
          //         title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
          //         variant: "success",
          //         solid: false,
          //       });

          //       this.onSearchSubmit({});
          //     } else {
          //       _this.$bvToast.toast("เกิดข้อผิดพลาด", {
          //         title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
          //         variant: "danger",
          //         solid: false,
          //       });
          //     }
          //   })
          //   .catch((error) => {
              // console.log("error", error);
              // _this.$bvToast.toast("เกิดข้อผิดพลาด", {
              //   title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
              //   variant: "danger",
              //   solid: false,
              // });
            // });
        }
      });
    },
    confirmText() {
      this.$swal({
        title: "คุณต้องการลบข้อมูลใช่หรือไม่?",
        text: "เมื่อลบแล้วไม่สามารถกู้คืนได้อีก!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "ลบข้อมูล",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$swal({
            icon: "success",
            title: "ลบข้อมูล สำเร็จ",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    },
  },
};
</script>
